var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_2757",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.916016,
    y: 0.916016,
    width: 32.084,
    height: 32.084,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_2757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.26367 26.316V23.6423H8.93734V14.2845C8.93734 12.4352 9.49435 10.792 10.6084 9.35494C11.7224 7.91784 13.1706 6.97649 14.9531 6.53088V5.59509C14.9531 5.03808 15.148 4.56462 15.5379 4.17471C15.9279 3.7848 16.4013 3.58984 16.9583 3.58984C17.5153 3.58984 17.9888 3.7848 18.3787 4.17471C18.7686 4.56462 18.9636 5.03808 18.9636 5.59509V6.53088C20.746 6.97649 22.1943 7.91784 23.3083 9.35494C24.4223 10.792 24.9793 12.4352 24.9793 14.2845V23.6423H27.653V26.316H6.26367ZM16.9583 30.3265C16.2231 30.3265 15.5936 30.0647 15.0701 29.5411C14.5465 29.0175 14.2847 28.3881 14.2847 27.6528H19.632C19.632 28.3881 19.3702 29.0175 18.8466 29.5411C18.323 30.0647 17.6936 30.3265 16.9583 30.3265ZM11.611 23.6423H22.3057V14.2845C22.3057 12.814 21.7821 11.5551 20.7349 10.508C19.6877 9.46077 18.4288 8.93717 16.9583 8.93717C15.4878 8.93717 14.229 9.46077 13.1818 10.508C12.1346 11.5551 11.611 12.814 11.611 14.2845V23.6423Z",
    fill: "white",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.4f860988f289262d9ee67ef7c54852aa.svg";
export { ForwardRef as ReactComponent };